import React, { useMemo } from "react";
// import { Freeze } from "react-freeze";
import GridLayout from "./GridLayout";
import useStore from "../../store";
import Tab from "./Tab";
import TabBackground from "./TabBackground";

export default function Tabs() {
    const currentTab = useStore((store) => store.dashboard.currentTab);
    const tabs = useStore((store) => store.dashboard.tabs);
    // const [freeze, setFreeze] = React.useState(false);
    // React.useEffect(() => {
    //     if (currentTab !== 0) {
    //         const timeOut = setTimeout(() => setFreeze(true), 1000);
    //         return () => {
    //             clearTimeout(timeOut);
    //         };
    //     }
    //     setFreeze(false);
    // }, [currentTab]);
    return (
        <div style={{
            position: "relative",
            overflow: "hidden",
            height: "100%",
            width: "100%",
            transform: "translate3d(0,0,0)",
        }}
        >
            <TabBackground />
            <div
                style={{
                    position: "relative",
                    overflow: "auto",
                    height: "100%",
                    width: "100%",
                }}
            >
                {/* <Freeze freeze={freeze}> */}
                {useMemo(() => (
                    <div style={{ display: currentTab !== 0 ? "none" : "block" }}>
                        <GridLayout
                            section="main"
                            cols="20"
                        />
                    </div>
                ), [currentTab])}
                {/* </Freeze> */}
                {useMemo(() => (
                    tabs.map((tab) => (
                        <div style={{ height: "100%", position: "relative", display: currentTab !== tab.id ? "none" : "block" }} key={tab.id}>
                            <div id={`tab-${tab.id}-container`} />
                            <Tab tab={tab} currentTab={currentTab} />
                        </div>
                    ))), [tabs, currentTab])}
            </div>
        </div>
    );
}
